import { combineReducers } from 'redux';
import { reducer as toastrReducer } from 'react-redux-toastr';
import assets from './reducers/assets';
import user from './reducers/user';
import company from './reducers/company';
import loader from './reducers/loader';
import partnerList from './reducers/partnerList';
import alertsearch from './reducers/alertsearch';
import tripreplay from './reducers/tripreplay';
import driver from './reducers/driver';
import notification from './reducers/notification';
import reports from './reducers/reports';
import dashboardData from './reducers/dashboardData';
import webfleetData from './reducers/webfleetData';
import partnerPortalRedirect from './reducers/partnerPortalRedirect';
import eventsData from './reducers/eventsData';
import ifta from './reducers/ifta'
import configs from './reducers/configs'
import zones from "./reducers/zones";

export default combineReducers({
	assets: assets,
	user,
	company,
	partnerList,
	alertsearch,
	tripreplay,
	toastr: toastrReducer,
	driver,
	notification,
	reports,
	dashboardData,
	loader,
	webfleetData,
	partnerPortalRedirect,
	eventsData,
	ifta,
	configs,
	zones,
})
